import { create } from "zustand";

const useSupportFeedbackStore = create((set) => ({
  isSupportModalOpen: false,
  modalContext: null,
  openSupportModal: (context = null) =>
    set({ isSupportModalOpen: true, modalContext: context }),
  closeSupportModal: () => set({ isSupportModalOpen: false, modalContext: null }),
}));

export default useSupportFeedbackStore;
